import { useTranslation } from 'react-i18next'
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import CustomSelect from '../../components/atoms/Inputs/CustomSelect'
import Select from 'react-select'

const LanguageSwitcher = () => {
    const [language, setLanuage] = useState(
        localStorage.getItem('language') ? localStorage.getItem('language') : 'for_english',
    )
    const { i18n } = useTranslation()

    const customStyles = {
        option: (styles, { isFocused, isSelected }) => ({
            ...styles,
            display: 'flex',
            alignItems: 'center',
            padding: 10,
            backgroundColor: isSelected ? '#007776' : 'white',
            color: isSelected ? 'white' : 'black',
        }),
    }

    const languages = [
        {
            image: '/assets/svg/united-kingdom-flag-icon.svg',
            language: 'EN',
            language_slug: 'for_english',
        },
        {
            image: '/assets/svg/sweden-flag-icon.svg',
            language: 'SV',
            language_slug: 'for_mandarin',
        },
    ]

    useEffect(() => {
        // if (!localStorage.getItem('language_loaded')) {
        getlanuagespharse()
        // }
    }, [language])

    const handleChange = (e) => {
        setLanuage(e.value)
        localStorage.removeItem('language_loaded')
        localStorage.setItem('language', e.value)
    }

    const getlanuagespharse = () => {
        const body = {
            site_id: process.env.REACT_APP_SITE_ID,
            language_name: language,
        }
        axios
            .post(`${process.env.REACT_APP_AUCTION_URL}languagedata`, body)
            .then(function (response) {
                try {
                    if (response.data.status === 'success') {
                        var name = []
                        if (response.data.response.results.length > 0) {
                            var arr = response.data.response.results
                            for (var i = 0; i < arr.length; i++) {
                                i18n.addResourceBundle(
                                    language,
                                    'translations',
                                    { [arr[i].phrase]: arr[i][language] },
                                    true,
                                    true,
                                )
                            }
                            localStorage.setItem('language_loaded', 1)
                            i18n.changeLanguage(language)
                        }
                    }
                } catch (e) {
                    console.error('Error while processing API response:', e)
                }
            })
            .catch((error) => {
                console.error('Error during API call:', error)
            })
    }

    const languageOptions = languages.map((opt) => ({
        value: opt.language_slug,
        label: (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <img
                    src={opt.image}
                    alt={opt.language}
                    style={{ width: 20, height: 15, marginRight: 8 }}
                />
                {opt.language}
            </div>
        ),
    }))

    return (
        <div>
            <Select
                options={languageOptions}
                value={languageOptions.find((opt) => opt.value === language)}
                onChange={handleChange}
                getOptionLabel={(e) => e.label}
                isSearchable={false}
                styles={customStyles}
            />
        </div>
    )
}

export default LanguageSwitcher
